"use client";

import {SessionProvider as Module} from "next-auth/react";

export default Module;
